export default "__VITE_ASSET__$zjkDS7D__"